import { captureException as sentryCaptureException } from '@sentry/react'

export const captureException = sentryCaptureException
